// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn_error_area[data-v-44f68e13] {width: 110px; font-size: 12px; text-align: center;}\n.btn_error_area + .btn_error_area[data-v-44f68e13] {margin-top: 5px;}\n.bl-highlight[data-v-44f68e13] {\n  font-weight: bold;\n  font-size: 20px;\n}\n.border_left_none[data-v-44f68e13] {\n  height: 45px;\n}\n.content_title span[data-v-44f68e13] {\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
